var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-popover", {
    attrs: {
      placement: _vm.placement,
      title: _vm.title,
      width: _vm.width,
      trigger: _vm.trigger
    }
  }, [_c("view-html", {
    attrs: {
      content: _vm.content
    }
  }), _c("span", {
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_c("cpsc-icon", {
    attrs: {
      hover: true,
      name: "el-icon-view"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };